/**
 * English strings every worksheet widget shares. Each widget spreads this object into its
 * own `<SLUG>_STRINGS`, so a translated content file overrides them through the same `ui`
 * map as the widget's own labels.
 */
export const WORKSHEET_COMMON_STRINGS = {
  paperLabel: "Paper size",
  papers: { letter: "US Letter (8.5 × 11 in)", a4: "A4 (210 × 297 mm)" },
  fontSizeLabel: "Problem size",
  fontSizes: {
    small: "Small (14 pt)",
    medium: "Medium (18 pt)",
    large: "Large (24 pt)",
  },
  countLabel: "Number of problems",
  layoutLabel: "Layout",
  layouts: { vertical: "Stacked (vertical)", horizontal: "One line" },
  columnsLabel: "Columns",
  columnsAuto: "Automatic",
  titleLabel: "Worksheet title",
  titleHint: "Leave blank to use the default title.",
  showHeader: "Name, date and score lines",
  numbered: "Number the problems",
  answerKey: "Answer key on a separate page",
  seedLabel: "Worksheet number",
  seedHint:
    "The same number with the same settings always gives the same worksheet. Type one to bring a sheet back.",
  seedInvalid: "Enter a whole number from 1 to 999999.",
  newWorksheet: "New worksheet",
  print: "Print",
  printHint:
    "In the print dialog choose the paper size above, set the scale to 100%, and turn off headers and footers. The answer key starts on its own page, so print page 1 for students.",
  nameLabel: "Name",
  dateLabel: "Date",
  scoreLabel: "Score",
  answerKeyTitle: "Answer key",
  seedCaption: "Worksheet {seed}",
  unmetNotice:
    "Some problems could not meet every setting at once, so they break one. Widen a number range or relax a rule.",
  remainderAbbr: "R",
  previewLabel: "Worksheet preview",
  keyLabel: "Answer key preview",
} as const;

export type WorksheetCommonStrings = typeof WORKSHEET_COMMON_STRINGS;
